import axios from "axios";

export default class Util {

    static openInNewTabDocument(data) {
        let binaryString = window.atob(data);
        let binaryLen = binaryString.length;
        let bytes = new Uint8Array(binaryLen);

        for (let i = 0; i < binaryLen; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }

        let blob = new Blob([bytes], {type: "application/pdf"});
        let link = URL.createObjectURL(blob);
        let newWindow = window.open(link, "_blank");
        if (!newWindow) {
            app.$toast.error({
                title: 'Felugró ablakok',
                message: 'Jelenleg a böngészőjében le vannak tiltva a felugró ablakok. Kérjük, a zavartalan használhatóség érdekében engedélyezze a felugró ablakokat a Medici oldalán!'
            });
        }
    }

    static downloadDocument(self, url, name, params={}) {
        axios({
            url: url,
            params: params,
            method: 'GET',
            responseType: 'blob', // important
        }).then((response) => {
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(new Blob([response.data]));
            link.setAttribute('download', name);
            document.body.appendChild(link);
            link.click();
            self.$loading(false);
        }).catch(err => {
            self.$loading(false);
            console.error(err);
            self.$toast.error({
                title: "Hiba!",
                message: "Hiba történt a letöltés közben!"
            })
        });
    }
    static downloadDocumentWithPost(self, url, name, params={}) {
        self.$loading(true);
        axios({
            url: url,
            data: params,
            method: 'POST',
            responseType: 'blob', // important
        }).then((response) => {
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(new Blob([response.data]));
            link.setAttribute('download', name);
            document.body.appendChild(link);
            link.click();
            self.$loading(false);
        }).catch(err => {
            self.$loading(false);
            console.error(err);
            self.$toast.error({
                title: "Hiba!",
                message: "Hiba történt a letöltés közben!"
            })
        });
    }

    static downloadOldLabDocument(self, url, name, params) {
        axios({
            url: url,
            params: params,
            method: 'GET',
            responseType: 'blob', // important
        }).then((response) => {
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(new Blob([response.data]));
            link.setAttribute('download', name);
            document.body.appendChild(link);
            link.click();
            self.$loading(false);
        }).catch(err => {
            self.$loading(false);
            console.error(err);
            self.$toast.error({
                title: "Hiba!",
                message: "Hiba történt a letöltés közben!"
            })
        });
    }

    static downloadXlsValidateResult(self, url, name, params={}) {
        axios({
            url: url,
            params: params,
            method: 'GET',
            responseType: 'blob', // important
        }).then((response) => {
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(new Blob([response.data]));
            link.setAttribute('download', name);
            document.body.appendChild(link);
            link.click();
            self.$loading(false);
        }).catch(err => {
            self.$loading(false);
            console.error(err);
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(new Blob([err.response.data]));
            link.setAttribute('download', name);
            document.body.appendChild(link);
            link.click();
        });
    }

    /**
     * A TAJ szám első nyolc számjegyéből a páratlan helyen állókat hárommal,
     * a páros helyen állókat héttel szorozzuk, és a szorzatokat összeadjuk.
     * Az összeget tízzel elosztva a maradékot tekintjük a kilencedik, azaz CDV kódnak.
     * @param socialInsuranceNumber
     */
    static isSocialInsuranceNumberCorrect(socialInsuranceNumber) {
        if (socialInsuranceNumber === '900-000-007') {
            return true;
        }
        let tmpTaj = socialInsuranceNumber.replace(/-/g, '');

        let tmpParatlanSum = tmpTaj[0] * 3 + tmpTaj[2] * 3 + tmpTaj[4] * 3 + tmpTaj[6] * 3;
        let tmpParosSum2 = tmpTaj[1] * 7 + tmpTaj[3] * 7 + tmpTaj[5] * 7 + tmpTaj[7] * 7;

        let tmpParosParatlanSum = tmpParatlanSum + tmpParosSum2;

        return tmpParosParatlanSum % 10 == tmpTaj[8];
    }

    static base64Decode(str) {
        return decodeURIComponent(atob(str).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    }

    static openInNewTabDocumentWithExtension(fileData, fileName) {
        let binaryString = window.atob(fileData);
        let binaryLen = binaryString.length;
        let bytes = new Uint8Array(binaryLen);
        for (let i = 0; i < binaryLen; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        let blob = new Blob([bytes], {type: this.getTypeByExtension(fileName.split('.').pop())});
        let link = URL.createObjectURL(blob);
        window.open(link, "_blank");
    }

    static getTypeByExtension(extension) {
        switch (extension.toLowerCase()) {
            case "pdf":
                return 'application/pdf';
            case "doc":
                return 'application/msword';
            case "docx":
                return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
            case "xls":
                return 'application/vnd.ms-excel';
            case "xlsx":
                return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            case "ppt":
                return 'application/vnd.ms-powerpoint';
            case "pptx":
                return 'application/vnd.openxmlformats-officedocument.presentationml.presentation';
            case "odt":
                return 'application/vnd.oasis.opendocument.text';
            case "ods":
                return 'application/vnd.oasis.opendocument.spreadsheet';
            case "odp":
                return 'application/vnd.oasis.opendocument.presentation';
            case "txt":
                return 'text/plain';
            case "jpg":
                return 'image/jpeg';
            case "jpeg":
                return 'image/jpeg';
            case "png":
                return 'image/png';
            case "bmp":
                return 'image/bmp';
            default:
                return '';
        }
    }

    // Formatters
    static formatEsemenyStatus(value) {
        switch (value) {
            case "FELVETEL":
                return "Felvétel";
            case "ELBOCSATAS":
                return "Elbocsátás";
            case "MEGKEZDES":
                return "Megkezdés";
            case "LEZARAS":
                return "Lezárás";
            case "ESEMENY":
                return "Esemény";
            default:
                return value
        }
    }
    static formatEsemenyTipus(value) {
        switch (value) {
            case "FEKVO_FELVETEL":
                return "Fekvőbeteg-szakellátás befejezése";
            case "FEKVO_ELBOCSATAS":
                return "Fekvőbeteg-szakellátás megkezdése";
            case "JARO_FELVETEL":
                return "Járóbeteg-szakellátás befejezése";
            case "JARO_ELBOCSATAS":
                return "Járóbeteg-szakellátás megkezdése";
            case "HAZIORVOS_FELVETEL":
                return "Háziorvosi ellátás befejezése";
            case "HAZIORVOS_ELBOCSATAS":
                return "Háziorvosi ellátás megkezdése";
            case "HAZIGYORVOS_FELVETEL":
                return "Házi gyermekorvosi ellátás befejezése";
            case "HAZIGYORVOS_ELBOCSATAS":
                return "Házi gyermekorvosi ellátás megkezdése";
            case "FOGORVOS_FELVETEL":
                return "Fogorvosi ellátás befejezése";
            case "FOGORVOS_ELBOCSATAS":
                return "Fogorvosi ellátás megkezdése";
            case "RADIOLOGIA_MEGKEZDES":
                return "Radiológiai CT-vizsgálat befejezése";
            case "RADIOLOGIA_BEFEJEZES":
                return "Radiológiai CT-vizsgálat megkezdése";
            case "MENTES_FELVETEL":
                return "Mentés betegszállítás befejezése";
            case "MENTES_ELBOCSATAS":
                return "Mentés betegszállítás megkezdése";
            case "SBO_MEGKEZDES":
                return "SBO ellátás megkezdése";
            case "SBO_TRIAGE":
                return "SBO ellátás során végrehajtott triázs/re-triázs";
            case "SBO_ELLATAS1":
                return "SBO ellátás során az első, orvos által végzett ellátási esemény";
            case "SBO_ELLATAS":
                return "SBO ellátás során végzett további ellátási események";
            case "SBO_TAVOZAS":
                return "SBO ellátás lezárása";
            case "HAZIKARANTEN_MEGKEZDES":
                return "Házi-karantén befejezése";
            case "HAZIKARANTEN_LEZARAS":
                return "Házi-karantén megkezdése";
            case "MLABOR_MEGKEZDES":
                return "Laboratóriumi vizsgálat lezárása";
            case "MLABOR_LEZARAS":
                return "Laboratóriumi vizsgálat megkezdése";
            case "CovidRapidTeszt":
                return "Covid gyorsteszt";
            case "FOG_ALAP_MEGKEZDES":
                return "Fogorvos es gyermek fogorvos alapellátás megkezdese";
            case "FOG_ALAP_LEZARAS":
                return "Fogorvos es gyermek fogorvos alapellátás lezárása";
            case "FOG_SZAK_MEGKEZDES":
                return "Fogorvos es gyermek fogorvos szakellátás megkezdese";
            case "FOG_SZAK_LEZARAS":
                return "Fogorvos es gyermek fogorvos szakellátás lezárása";
            case "FOG_ISK_MEGKEZDES":
                return "Iskolafogászat megkezdése";
            case "FOG_ISK_LEZARAS":
                return "Iskolafogászat lezárása";
            case "ISKOLA_EU_MEGKEZDES":
                return "Iskolaegeszségügyi ellátás megkezdése";
            case "ISKOLA_EU_LEZARAS":
                return "Iskolaegészségügyi ellátás lezárása";
            case "DIALIZIS_MEGKEZDES":
                return "Művesekezelés megkezdése";
            case "DIALIZIS_LEZARAS":
                return "Művesekezelés lezárása";
            case "LABOR_MEGKEZDES":
                return "Laboratóriumi diagnosztikai vizsgálat megkezdése";
            case "LABOR_LEZARAS":
                return "Laboratóriumi diagnosztikai vizsgálat lezárása";
            case "VARANDOS_GONDOZAS":
                return "Várandós gondozási esemény";
            case "GYERMEKAGYAS_GONDOZAS":
                return "Gyermekágyas gondozási esemény";
            case "GYERMEK_GONDOZAS":
                return "Gyermek gondozási esemény";
            case "NOVODELMI_GONDOZAS":
                return "Nővédelmi gondozási esemény";
            case "VEDONOI_SZURES":
                return "A 2015. évi CXXIII. törvény 13.§ (2) bek. szerinti, védőnő által végzett szűrés";
            case "PSZICHO_MEGKEZDES":
                return "Pszichoterápia és klinikai szakpszichológiai ellátás megkezdése";
            case "PSZICHO_LEZARAS":
                return "Pszichoterápia és klinikai szakpszichológiai ellátás lezárása";
            case "NEM_KONVENCIONÁLIS_MEGKEZDES":
                return "11/1997. (V. 28.) NM rendelet szerinti, csak orvos által végezhető nem-konvencionális tevékenység megkezdése";
            case "NEM_KONCENVIONÁLIS_LEZARAS":
                return "11/1997. (V. 28.) NM rendelet szerinti, csak orvos által végezhető nem-konvencionális tevékenység lezarasa";
            case "HAZIORVOS_UGYELET_MEGKEZDES":
                return "Háziorvosi, házi gyermekorvosi ügyeleti ellátás megkezdése";
            case "HAZIORVOS_UGYELET_LEZARAS":
                return "Háziorvosi, házi gyermekorvosi ügyeleti ellátás lezarasa";
            case "FOG_UGYELET_MEGKEZDES":
                return "Fogorvosi ügyeleti ellátás megkezdése";
            case "FOG_UGYELET_LEZARAS":
                return "Fogorvosi ügyeleti ellátás lezárása";
            case "FURDO_MEGKEZDES":
                return "Fürdőgyógyászati ellátás megkezdése";
            case "FURDO_LEZARAS":
                return "Fürdőgyógyászati ellátás lezárása";
            case "FIZIO_MEGKEZDES":
                return "Fizioterápia (elrendelés alapján) megkezdése";
            case "FIZIO_LEZARAS":
                return "Fizioterápia (elrendelés alapján) lezaras";
            case "FOGLEU_ALAP_MEGKEZDES":
                return "Foglalkozás-egészségügyi alapellátás megkezdése";
            case "FOGLEU_ALAP_LEZARAS":
                return "Foglalkozás-egészségügyi alapellátás lezarasa";
            case "FOGLEU_SZAK_MEGKEZDES":
                return "Foglalkozás-egészségügyi szakellátás megkezdese";
            case "FOGLEU_SZAK_LEZARAS":
                return "Foglalkozás-egészségügyi szakellátás lezárása";
            case "RENDVEDELEM_MEGKEZDES":
                return "Rend- és honvédelmi dolgozók orvosi ellátásának megkezdése";
            case "RENDVEDELEM_LEZARAS":
                return "Rend- és honvédelmi dolgozók orvosi ellátásának lezárása";
            case "HALOTTVIZSGALAT_MEGKEZDES":
                return "Pathológia halottvizsgálat";
            case "HALOTTVIZSGALAT_BEFEJEZES":
                return "Pathológia halottvizsgálat";
            case "EGYNAPOS_MEGKEZDES":
                return "Egynapos sebészet megkezdése";
            case "EGYNAPOS_LEZARAS":
                return "Egynapos sebészet befejezése";
            case "KURASZERU_MEGKEZDES":
                return "Kúraszerű ellátás megkezdése";
            case "KURASZERU_LEZARAS":
                return "Kúraszerű ellátás befejezése";
            case "REHABILITACIOS_SZAKERTO_MEGKEZDES":
                return "Rehabilitációs hatósági vizsgálat";
            case "REHABILITACIOS_SZAKERTO_LEZARAS":
                return "Rehabilitációs hatósági vizsgálat";
            case "COVID_VEDOOLTAS":
                return "COVID védőoltás";
            default:
                return value
        }
    }

    static getEesztDocumentTypeByPatientDocumentType(patientDocumentType) {
        switch (patientDocumentType) {
            case "útlevél":
                return 3;
            case "menedékes, kérelmező, befogadó ig. száma":
                return 5;
            case "Európai egészségbiztosítási kártya":
                return 8;
            case "menekült, menedékes és oltalmazott státusz kérelmezése elött":
                return 9;
            case "személyi igazolvány":
                return 21;
            case "EESZT technikai azonosító (PID azonosító)":
                return 20;
            case "Tartózkodási engedély szám":
                return 22;
            case "jogosítvány":
                return null;
            default:
                return 1;
        }
    }

}
